import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const QuickActionCards = () => {
  const actionCards = [
    {
      id: 1,
      title: "Prospective Students",
      description:
        "Discover our accredited technical and vocational programs, admission requirements, and pathways to kickstart your career in industry and innovation.",
      icon: "GraduationCap",
      color: "bg-primary",
      actions: [
        { label: "Browse Courses", link: "/courses", icon: "BookOpen" },
        { label: "Apply Now", link: "https://karumottiportal.ac.ke/Account/StudentApplication?returnUrl=%2FAppAdmin", external:true, icon: "Send" },
      ],
    },
    {
      id: 2,
      title: "Current Students",
      description:
        "Stay connected to campus life with quick access to your student portal, academic records, learning materials, and support services.",
      icon: "User",
      color: "bg-yellow-500",
      actions: [
        { label: "Student Portal", link: "https://karumottiportal.ac.ke/", external: true, icon: "LogIn" },
        { label: "Resources", link: "/resources", icon: "FileText" },
      ],
    },
    {
      id: 3,
      title: "Dual TVET Program",
      description:
        "Partner with us to bridge the gap between training and employment through industry-based learning, apprenticeships, and workforce development programs.",
      icon: "Building2",
      color: "bg-blue-500",
      actions: [
        { label: "Become a Partner", link: "/contact", icon: "Handshake" },
        { label: "Hire Graduates", link: "/contact", icon: "Users" },
      ],
    },
    {
      id: 4,
      title: "Recognition of Prior Learning (RPL)",
      description:
        "Unlock your potential and turn your experience into a recognized qualification! Through our Recognition of Prior Learning (RPL) program, you can fast-track your career by converting your existing knowledge into nationally recognized credentials.",
      icon: "Award",
      color: "bg-yellow-600",
      actions: [
        { label: "Apply for RPL", link: "/resources?tab=documents", icon: "FileCheck" },
        { label: "Learn More", link: "/contact", icon: "Info" },
      ],
    },
  ];

  return (
    <section className="py-16 bg-blue-100">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Choose Your Path
          </h2>
          <p className="text-xl text-muted-black w-fit mx-auto">
            Whether you’re launching your career or upgrading your skills,
            Karumo TTI is your gateway to success. Join us and become part of a
            vibrant learning community where<em><b> creativity and innovation delivers
            solution!</b></em>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {actionCards?.map((card) => (
            <div
              key={card?.id}
              className="bg-card rounded-xl shadow-card hover:shadow-card-lg transition-all duration-300 overflow-hidden group"
            >
              {/* Header */}
              <div
                className={`${card?.color} p-6 text-white relative overflow-hidden`}
              >
                <div className="absolute top-0 right-0 w-20 h-20 bg-white/10 rounded-full -mr-10 -mt-10"></div>
                <div className="relative z-10">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                    <Icon name={card?.icon} size={24} color="white" />
                  </div>
                  <h3 className="text-2xl font-bold mb-2">{card?.title}</h3>
                  <p className="text-white/90 text-lg">{card?.description}</p>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="space-y-3 mb-6">
                  {card?.actions?.map((action, index) => (
                    action?.external ? (
                      <a key={index} href={action?.link} target="_blank" rel="noopener noreferrer">
                        <Button
                          variant="ghost"
                          fullWidth
                          iconName={action?.icon}
                          iconPosition="left"
                          className="justify-start hover:bg-yellow-700"
                        >
                          {action?.label}
                        </Button>
                      </a>
                    ) : (
                      <Link key={index} to={action?.link}>
                        <Button
                          variant="ghost"
                          fullWidth
                          iconName={action?.icon}
                          iconPosition="left"
                          className="justify-start hover:bg-yellow-700"
                        >
                          {action?.label}
                        </Button>
                      </Link>
                    )
                  ))}
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickActionCards;
